export default "__VITE_ASSET__CxR78vmg__"